<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        Agregar punto de control
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="functionForm">
        <div class="form-group">
            <label for="checkPoint" class="form-label">Punto de control</label>
            <input type="text" class="form-control" id="checkPoint" formControlName="checkPoint">
        </div>
        <p *ngIf="functionForm.controls['checkPoint'].touched && functionForm.controls['checkPoint'].invalid"
            class="text-danger">
            Este campo es requerido</p>
        <div class="form-group">
            <label for="priority" class="form-label">Prioridad</label>
            <select id="priority" class="form-control" formControlName="priority">
                <option value="" disabled>Seleccionar prioridad</option>
                <option value="AAA">AAA</option>
                <option value="AA">AA</option>
                <option value="A">A</option>
            </select>
        </div>
        <p *ngIf="functionForm.controls['priority'].touched && functionForm.controls['priority'].invalid"
            class="text-danger">
            Este campo es requerido</p>
        <div class="form-group">
            <label for="period" class="form-label">Periodo</label>
            <select id="period" class="form-control" formControlName="period">
                <option value="" disabled>Seleccionar periodo</option>
                <option [ngValue]="1">Diaria</option>
                <option [ngValue]="7">Semanal</option>
                <option [ngValue]="15">Quincenal</option>
                <option [ngValue]="30">Mensual</option>
            </select>
        </div>
        <p *ngIf="functionForm.controls['period'].touched && functionForm.controls['period'].invalid"
            class="text-danger">
            Este campo es requerido</p>
        <div class="form-group">
            <label for="supervisorPeriod" class="form-label">Periodo del supervisor</label>
            <select id="supervisorPeriod" class="form-control" formControlName="supervisorPeriod">
                <option value="" disabled>Seleccionar periodo</option>
                <option [ngValue]="1">Diaria</option>
                <option [ngValue]="7">Semanal</option>
                <option [ngValue]="15">Quincenal</option>
                <option [ngValue]="30">Mensual</option>
            </select>
        </div>
        <p *ngIf="functionForm.controls['supervisorPeriod'].touched && functionForm.controls['supervisorPeriod'].invalid"
            class="text-danger">
            Este campo es requerido</p>
        <div class="form-group">
            <label for="auditorPeriod" class="form-label">Periodo del auditor</label>
            <select id="auditorPeriod" class="form-control" formControlName="auditorPeriod">
                <option value="" disabled>Seleccionar periodo</option>
                <option [ngValue]="1">Diaria</option>
                <option [ngValue]="7">Semanal</option>
                <option [ngValue]="15">Quincenal</option>
                <option [ngValue]="30">Mensual</option>
            </select>
        </div>
        <p *ngIf="functionForm.controls['auditorPeriod'].touched && functionForm.controls['auditorPeriod'].invalid"
            class="text-danger">
            Este campo es requerido</p>
    </form>
    <div class="btn-group">
        <input class="form-control" type="file" id="formFile" (change)="uploadFile($event.target)"
            accept="application/pdf" style="display: none;" #file>
        <button class="btn btn-sm btn-icon btn-success" (click)="file.click()" ngbTooltip="Subir PDF"
            [disabled]="isUploadingFile">
            <span class="material-icons">
                upload
            </span>
        </button>
        <button class="btn btn-sm btn-icon btn-info" (click)="downloadFile()" ngbTooltip="Descargar PDF"
            *ngIf="functionForm.value.url">
            <span class="material-icons">
                download
            </span>
        </button>
    </div>
    <div class="progress" *ngIf="isUploadingFile">
        <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width': currentPercentage + '%'}"
            aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</div>
<div class="modal-footer">
    <div class="btn-group w-100" role="group">
        <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success" [disabled]="functionForm.invalid || isSaving" (click)="save()">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>